/* global GEO_SHA */

/**
 * The current geojs git SHA.
 *
 * @alias geo.sha
 * @constant
 * @type {string}
 */
module.exports = GEO_SHA;
